import ApiService from "service/Api";

const PointActivityService = {
  getPointActivities: async (
    page: number,
    search: string,
    limit: number,
    filterPointType: string
  ) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      params: {
        search: search,
        page: page,
        per_page: limit,
        filter_point_type: filterPointType,
      },
      url: "admin/point-activities",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },
};

export default PointActivityService;
